import { render, staticRenderFns } from "./mrp-list.vue?vue&type=template&id=3e909007"
import script from "./mrp-list.vue?vue&type=script&lang=js"
export * from "./mrp-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports